var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H28V28H0V0Z",
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_628_2",
    transform: "translate(0 -0.0113636) scale(0.0227273)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_628_2",
    width: 44,
    height: 45,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAAtCAYAAADV2ImkAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAGWSURBVHgB7ZjhcYMgFICfXv/XDcoI3aBmknSDjpB0goxgNsgIdoOkE0gmaDZ4fbRwQQsqCsH0+O7eoUD084VL8AEkEolEIiZZ3yAiMmpUPFIUcohp0xiMh8v2IkNw7oydsiy7gAtClKLGeBxksv6QmWSpOcI1m7HgFCvKNtc7TcINuH3NIfkg4ZXekesnJFvCcmQFJTk96R15ZwKH6+JfAiLD58FZ9FSvYmlgPGqKF3AlgnjtJEqTCzT8nNxAvDaJ2nz0CUxeoOpOlGMbz+INxdoiuqX4Mo2bhHFAfIfzECJvA6IKJ2GVha1FvEJ30Y0QM9zbtuychXXxteUzFU4XLbF/mU0WniI+JFqPuN9s4THiOynKZoh6F+4V9yAaTFgXLy3XPOB0WsIP4A9GUdMNOLUn+N2gP8vwhk9hBYOAO74c7owkHJokHJp7EG7VKFrC8pXarYgRnk/9xJThd1gO+25dwgj9W+0xPg32vR4ZpMWG+oi3p0HLllSQOTyAKmgwrVsdFzC+tMUNxz/tqBpEIpFI/C++Afqw3c5Bj8aCAAAAAElFTkSuQmCC"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.29071d85f67fb4c8b8152c5cd98f29dd.svg";
export { ForwardRef as ReactComponent };